import React from 'react';
import { useGlobalState } from '../../stateProvider/StateProvider';
import Input from '../../forms/Input';
import FormSetting from '../../layout/FormSetting';
import { QuestRoute } from '../../api/QuestRoutes';
import PageBreak from '../../layout/PageBreak';
import HamQuest from '../../api/HamQuestGiver';
import { Regex } from '../../utility/regex';
import EmailInput from '../../forms/formComponents/EmailInput';
import Checkbox from '../../forms/Checkbox';
import { generateId, getLocal, setLocal } from '../../utility/functions';
import { SeasonalToggle } from '../../Seasonal';
import ThemeSelector from '../../layout/ThemeSelector';
import Row from '../../layout/Row';
import Heading from '../../forms/Heading';
import ModalFactory from '../../Modal';
import Form from '../../forms/Form';
import Button from '../../forms/Button';

const Details = ({ ...props }) => {
    const {
        getUserData
    } = useGlobalState();

    const resetPassword = () => {
        const id = generateId();
        const { show, update } = ModalFactory
        show({
            id,
            title: 'Reset Password',
            body: (
                <Form
                    inputs={{
                        currentPassword: '',
                        newPassword: ''
                    }}
                    onSubmit={e => (
                        HamQuest.post(QuestRoute.settings.resetPassword, e)
                            .then(() => update({
                                id,
                                type: 'success',
                                title: 'Success',
                                body: 'Your password was successfully updated.'
                            }))
                    )}
                    text='Update'
                >
                    {({ values }) => (
                        <>
                            <Input
                                label='Password'
                                name='currentPassword'
                                type='password'
                                required
                            />
                            <Input
                                label='New Password'
                                name='newPassword'
                                type='password'
                                validate={Regex.test.password}
                                required
                            />
                            <Input
                                label='Confirm Password'
                                name='confirmPass'
                                type='password'
                                confirmation='newPassword'
                                required
                            />
                        </>
                    )}
                </Form>
            )
        })
    }

    return (
        <PageBreak>
            <FormSetting
                label={`User's Name`}
                getInputs={QuestRoute.roles}
                onSubmit={e => {
                    delete e.roles;
                    delete e.locations;

                    return HamQuest.put(QuestRoute.settings.updateUser, e)
                        .then(() => getUserData())
                }}
                text='Update User'
                controls={[
                    <Button
                        label='Reset Password'
                        onClick={resetPassword}
                    />
                ]}
                editable
            >
                <EmailInput />
                <Input
                    label='First Name'
                    name='firstName'
                    required
                />
                <Input
                    label='Last Name'
                    name='lastName'
                    required
                />
            </FormSetting>

            <FormSetting
                label={`User's Settings`}
                wrapper
            >
                <SeasonalToggle />
                <ThemeSelector />
            </FormSetting>

        </PageBreak>
    );
}

export default Details;